const openButton = document.getElementById("menu-btn-open");
const closeButton = document.getElementById("menu-btn-close");
const menu = document.getElementById("menu-inner");
const logo = document.getElementById("main-logo");
const overlay = document.querySelector("div#overlay");
const menuVisible = document.querySelector("div.main-menu__visible");
const body = document.getElementsByTagName("body")[0];

openButton.addEventListener("click", () => {
  body.classList.add("frozen");

  menu.classList.remove("right");
  menu.classList.add("left");
  menu.classList.add("menu-inner--open");
  menu.style.width = "100%";
  logo.classList.add("active");
  closeButton.classList.add("active");
  overlay.classList.add("active");
  menuVisible.classList.add("active");
});
closeButton.addEventListener("click", () => {
  body.classList.remove("frozen");
  menu.classList.remove("left");
  menu.classList.add("right");
  menu.classList.remove("menu-inner--open");
  menu.style.width = "0%";
  logo.classList.remove("active");
  closeButton.classList.remove("active");
  overlay.classList.remove("active");
  menuVisible.classList.remove("active");
});

let submit = document.querySelector("input.wpcf7-submit");
if (submit) {
  const wrapper = document.createElement("button");
  wrapper.setAttribute("class", "primary-btn-contact");
  const contactSubmit = document.querySelector("input.wpcf7-submit");
  contactSubmit.parentNode.insertBefore(wrapper, contactSubmit);
  wrapper.appendChild(contactSubmit);
}

//Accordion
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

//Set btns height - Shop
let btn = document.getElementsByClassName("add_to_cart_button");
let btnWrapper = document.getElementsByClassName(".add-wrapper")[0];
Array.from(btn).forEach(function(child) {
  let btnWrapper = child.parentNode;
  let btnHeight = parseInt(window.getComputedStyle(child).height) + "px";
  btnWrapper.style.height = btnHeight;
});



// WEBPACK FOOTER //
// ./resources/assets/js/webcommitment.js